<nz-alert class="mb-2" *ngIf="error" nzType="error"
          [nzMessage]="lastErrorMessage"
          nzShowIcon></nz-alert>
<ng-template #lastErrorMessage>
  {{interfaceService.errorHandling(error, false) || 'Неопознаная ошибка, напишите нам или попробуйте чуть позже.'}}
</ng-template>
